import React from "react";
import SortingVisualizer from "./Components/SortingVisualizer";
import "./index.css";

function App() {
  return (
    <div className="App">
      <SortingVisualizer />
    </div>
  );
}

export default App;
